import type { FireTrackAnalyticsPayload } from '@atlassian/jira-analytics-web-react/src';
import { fireTrackAnalytics } from '@atlassian/jira-analytics-web-react/src/utils/fire-track-event.tsx';
import type { AnalyticsEvent } from '@atlassian/jira-common-analytics-v2-wrapped-components/src/types';
import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types';
import { safeProjectType } from '@atlassian/jira-project-config/src/analytics';

export const onProjectDeleteSuccess = (
	event: AnalyticsEvent,
	projectId: number,
	projectType: ProjectType,
	fireTrack: (
		arg1: AnalyticsEvent,
		payload: FireTrackAnalyticsPayload,
	) => void = fireTrackAnalytics,
): void => {
	const payload = {
		action: 'deleted',
		containerType: 'project',
		containerId: projectId.toString(),
		attributes: {
			projectType: safeProjectType(projectType),
			simplified: true,
			tags: ['donut-world', 'project-details'],
		},
	};

	// every time I read 'fireTrackAnalytics' I imagine http://i0.kym-cdn.com/photos/images/original/000/544/719/a6c.png
	fireTrack(event, payload);
};
